import React, { useState } from 'react';
import './index.scss';
import RegistrationModal from '../../../Components/Product/GksSeminar/RegistrationModal';

const GksSeminarProduct: React.FC = () => {
    const [showForm, setShowForm] = useState(false);

    const openForm = () => {
        setShowForm(true);
    };

    const closeForm = () => {
        setShowForm(false);
    };

    return (
        <div className="gks-seminar-page">
            <div className="page-container">
                <img src="https://static.koreanmate.app/product/250912-gks-seminar/page01.jpg" alt="GKS Seminar Header" className="page-image" />
            </div>
            
            <div className="page-container">
                <img src="https://static.koreanmate.app/product/250912-gks-seminar/page02.jpg" alt="Program Details" className="page-image" />
            </div>
            
            <div className="page-container">
                <img src="https://static.koreanmate.app/product/250912-gks-seminar/page03.jpg" alt="Benefits" className="page-image" />
            </div>
            
            <div className="page-container">
                <img src="https://static.koreanmate.app/product/250912-gks-seminar/page04.jpg" alt="Schedule" className="page-image" />
            </div>
            
            <div className="page-container">
                <img src="https://static.koreanmate.app/product/250912-gks-seminar/page05.jpg" alt="Registration Info" className="page-image" />
            </div>
            
            <div className="page-container">
                <button className="page-button" onClick={openForm}>
                    <img src="https://static.koreanmate.app/product/250912-gks-seminar/page06.jpg" alt="Register Now" className="page-image" />
                </button>
            </div>
            
            <div className="page-container">
                <img src="https://static.koreanmate.app/product/250912-gks-seminar/page07.jpg" alt="Registration Info" className="page-image" />
            </div>
            
            <div className="page-container">
                <button className="page-button" onClick={openForm}>
                    <img src="https://static.koreanmate.app/product/250912-gks-seminar/page08.jpg" alt="Register Now" className="page-image" />
                </button>
            </div>
            
            <div className="page-container">
                <img src="https://static.koreanmate.app/product/250912-gks-seminar/page09.jpg" alt="Registration Info" className="page-image" />
            </div>
            
            <RegistrationModal isOpen={showForm} onClose={closeForm} />
            
            <div className="fab-container" onClick={openForm}>
                <img src="https://static.koreanmate.app/product/studyabroad/fab.png" alt="Register" className="fab-button" />
            </div>
        </div>
    );
};

export default GksSeminarProduct;